import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import remarkMath from 'remark-math';
import remarkGFM from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import ReactMarkdown from 'react-markdown';
import remarkDirective from 'remark-directive';
import visit from 'unist-util-visit';

import Heading from './heading.component';
import { Link } from '../link/link.component';
import { Math } from './math';
import Quote from './quote.component';
import { identifiers } from '../../utils/rendering';
import { CountdownDate } from '../countdownDate';

const tf = node => {
  if (
    node.type === 'textDirective' ||
    node.type === 'leafDirective' ||
    node.type === 'containerDirective'
  ) {
    // eslint-disable-next-line no-param-reassign
    node.data = node.data || {};
    const { data } = node;
    data.hName = node.name;
    data.hProperties = { ...node.attributes };
  }
};

function customDirectives() {
  return tree => {
    visit(tree, tf);
  };
}

export class Text extends PureComponent {
  static propTypes = {
    contentType: PropTypes.string,
    entryId: PropTypes.string,
    children: PropTypes.any,
    text: PropTypes.string,
    renderers: PropTypes.objectOf(PropTypes.func),
    className: PropTypes.string,
    src: PropTypes.string,
  };

  render() {
    const { contentType, entryId, renderers } = this.props;
    const text = this.props.children || this.props.text;
    const componentMap = {
      blockquote: ({ children }) => <Quote>{children}</Quote>,
      link: ({ children, href, ...props }) => (
        <Link {...props} url={href}>
          {children}
        </Link>
      ),
      h1: props => <Heading {...props} />,
      math: props => <Math mathText={props.value} displayMode={true} />,
      inlinemath: props => <Math mathText={props.value} />,
      table: ({ children }) => {
        return (
          <div className="table-wrap">
            <table>{children}</table>
          </div>
        );
      },
      img: props => {
        const { src } = props;

        return (
          <picture>
            <source
              media="(max-width: 1023px)"
              type="image/webp"
              srcSet={`${src}?fm=webp&w=455 1x, ${src}?fm=webp&w=683 1.5x, ${src}?fm=webp&w=910 2x`}
            />
            <img
              {...props}
              alt={props.alt || ''}
              srcSet={`${src}?fm=webp&w=640 1x, ${src}?fm=webp&w=960 1.5x, ${src}?fm=webp&w=1280 2x`}
              loading="lazy"
              src={`${src}?fm=webp&w=1280`}
            />
          </picture>
        );
      },
      countdowndate: props => {
        return <CountdownDate date={new Date(props.children)} />;
      },
      p: props => {
        // Prevents specific children from being wrapped in a <p></p> (Needed if children contain a <div />)
        if (props.node.children.filter(child => child.tagName === 'countdownDate').length) {
          return props.children;
        }

        return <p>{props.children}</p>;
      },
      ...renderers,
    };
    return (
      <ReactMarkdown
        components={componentMap}
        className={this.props.className}
        remarkPlugins={[remarkMath, remarkDirective, customDirectives, remarkGFM]}
        rehypePlugins={[rehypeRaw]}
        {...identifiers('Text', contentType, entryId)}
      >
        {text}
      </ReactMarkdown>
    );
  }
}
